module.exports = __webpack_public_path__ + "img/google.4960e95b.png";